// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as PoweredBy$OrcaPaymentPage from "./Components/PoweredBy.bs.js";
import * as CardPayment$OrcaPaymentPage from "./Payments/CardPayment.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./hyper-log-catcher/ErrorBoundary.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./Utilities/RecoilAtomsV2.bs.js";
import * as PaymentOptions$OrcaPaymentPage from "./PaymentOptions.bs.js";
import * as PaymentUtilsV2$OrcaPaymentPage from "./Utilities/PaymentUtilsV2.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "./Types/PaymentModeType.bs.js";
import * as AccordionContainer$OrcaPaymentPage from "./Components/AccordionContainer.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";

function cardsToRender(width) {
  return (width - 40 | 0) / 130 | 0;
}

function PaymentElementV2(props) {
  var cvcProps = props.cvcProps;
  var expiryProps = props.expiryProps;
  var cardProps = props.cardProps;
  var divRef = React.useRef(null);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var optionAtomValue = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var match$1 = Recoil.useRecoilState(PaymentUtils$OrcaPaymentPage.paymentManagementListValue);
  var setPaymentManagementListValue = match$1[1];
  var match$2 = React.useState(function () {
        return [];
      });
  var setPaymentOptions = match$2[1];
  var paymentOptions = match$2[0];
  var match$3 = React.useState(function () {
        return 0;
      });
  var cardsContainerWidth = match$3[0];
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match.layout);
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var setSelectedOption = match$4[1];
  var selectedOption = match$4[0];
  var match$5 = React.useState(function () {
        return [];
      });
  var setDropDownOptions = match$5[1];
  var dropDownOptions = match$5[0];
  var match$6 = React.useState(function () {
        return [];
      });
  var setCardOptions = match$6[1];
  var cardOptions = match$6[0];
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var setShowPaymentMethodsScreen = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var match$7 = PaymentUtilsV2$OrcaPaymentPage.useGetPaymentMethodListV2(paymentOptions);
  var paymentOptionsList = match$7[0];
  React.useEffect((function () {
          setShowPaymentMethodsScreen(function (param) {
                return true;
              });
        }), []);
  React.useEffect((function () {
          var exit = 0;
          if (typeof paymentManagementList !== "object") {
            if (paymentManagementList !== "LoadingV2") {
              exit = 1;
            }
            
          } else if (paymentManagementList.TAG === "LoadedV2") {
            var paymentlist = paymentManagementList._0;
            setPaymentOptions(function (param) {
                  return Utils$OrcaPaymentPage.removeDuplicate(Belt_Array.concatMany([paymentOptionsList]));
                });
            setPaymentManagementListValue(function (param) {
                  return paymentlist;
                });
          } else {
            exit = 1;
          }
          if (exit === 1) {
            setPaymentOptions(function (param) {
                  return ["card"];
                });
          }
          
        }), [
        paymentManagementList,
        paymentOptionsList,
        match$7[1]
      ]);
  React.useEffect((function () {
          if (layoutClass.type === "Tabs") {
            var isCard = cardOptions.includes(selectedOption);
            if (!isCard) {
              var match = CardUtils$OrcaPaymentPage.swapCardOption(cardOptions, dropDownOptions, selectedOption);
              var dropdownArr = match[1];
              var cardArr = match[0];
              setCardOptions(function (param) {
                    return cardArr;
                  });
              setDropDownOptions(function (param) {
                    return dropdownArr;
                  });
            }
            
          }
          if (selectedOption !== "") {
            loggerState.setLogInfo("", "PAYMENT_METHOD_CHANGED", undefined, undefined, undefined, undefined, selectedOption.toUpperCase());
          }
          
        }), [
        selectedOption,
        cardOptions,
        dropDownOptions
      ]);
  React.useEffect((function () {
          var cardsCount = cardsToRender(cardsContainerWidth);
          var cardOpts = paymentOptions.slice(0, cardsCount);
          var dropOpts = paymentOptions.slice(cardsCount);
          var isCard = cardOpts.includes(selectedOption);
          if (!isCard && selectedOption !== "" && paymentOptions.includes(selectedOption)) {
            var match = CardUtils$OrcaPaymentPage.swapCardOption(cardOpts, dropOpts, selectedOption);
            var dropdownArr = match[1];
            var cardArr = match[0];
            setCardOptions(function (param) {
                  return cardArr;
                });
            setDropDownOptions(function (param) {
                  return dropdownArr;
                });
          } else {
            setCardOptions(function (param) {
                  return cardOpts;
                });
            setDropDownOptions(function (param) {
                  return dropOpts;
                });
          }
        }), [
        cardsContainerWidth,
        paymentOptions
      ]);
  var cardShimmerCount = React.useMemo((function () {
          return cardsToRender(cardsContainerWidth);
        }), [cardsContainerWidth]);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && selectedOption === "") {
            return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", "Select a payment method");
          }
          
        }), [selectedOption]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  React.useEffect((function () {
          setSelectedOption(function (prev) {
                if (selectedOption !== "") {
                  return prev;
                } else if (layoutClass.defaultCollapsed) {
                  return "";
                } else if (typeof paymentManagementList !== "object") {
                  if (paymentManagementList === "LoadingV2") {
                    return Core__Option.getOr(paymentOptions[0], "");
                  } else {
                    return "card";
                  }
                } else if (paymentManagementList.TAG === "LoadedV2") {
                  if (paymentOptions.includes(selectedOption)) {
                    return selectedOption;
                  } else {
                    return Core__Option.getOr(paymentOptions[0], "");
                  }
                } else {
                  return "card";
                }
              });
        }), [
        layoutClass.defaultCollapsed,
        paymentOptions,
        paymentManagementList,
        selectedOption
      ]);
  var match$8 = PaymentModeType$OrcaPaymentPage.paymentMode(selectedOption);
  var tmp;
  tmp = match$8 === "Card" ? React.createElement(CardPayment$OrcaPaymentPage.make, {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }) : null;
  var checkoutEle = JsxPPXReactSupportU.createElementWithKey(selectedOption, ErrorBoundary$OrcaPaymentPage.make, {
        children: tmp,
        componentName: "PaymentElement"
      });
  var paymentLabel = optionAtomValue.paymentMethodsHeaderText;
  React.useEffect((function () {
          var evalMethodsList = function () {
            if (typeof paymentManagementList !== "object" && paymentManagementList === "LoadingV2") {
              return ;
            }
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                    "ready",
                    true
                  ]]);
          };
          evalMethodsList();
        }), [paymentManagementList]);
  var match$9 = layoutClass.type;
  var tmp$1;
  tmp$1 = match$9 === "Accordion" ? React.createElement(AccordionContainer$OrcaPaymentPage.make, {
          paymentOptions: paymentOptions,
          checkoutEle: checkoutEle,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }) : React.createElement(PaymentOptions$OrcaPaymentPage.make, {
          setCardsContainerWidth: match$3[1],
          cardOptions: cardOptions,
          dropDownOptions: dropDownOptions,
          checkoutEle: checkoutEle,
          cardShimmerCount: cardShimmerCount,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        });
  var tmp$2;
  var exit = 0;
  if (typeof paymentManagementList !== "object" || paymentManagementList.TAG !== "LoadErrorV2") {
    exit = 1;
  } else {
    tmp$2 = React.createElement(RenderIf$OrcaPaymentPage.make, {
          condition: match$1[0].paymentMethodsEnabled.length === 0,
          children: React.createElement(ErrorBoundary$OrcaPaymentPage.ErrorTextAndImage.make, {
                divRef: divRef,
                level: "Top"
              })
        });
  }
  if (exit === 1) {
    tmp$2 = React.createElement(RenderIf$OrcaPaymentPage.make, {
          condition: paymentOptions.length === 0,
          children: React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {})
        });
  }
  return React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: Core__Option.isSome(paymentLabel),
                  children: React.createElement("div", {
                        className: "text-2xl font-semibold text-[#151619] mb-6"
                      }, Core__Option.getOr(paymentLabel, ""))
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: paymentOptions.length > 0,
                  children: React.createElement("div", {
                        className: "flex flex-col place-items-center"
                      }, tmp$1)
                }), tmp$2, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: props.paymentType !== "PaymentMethodsManagement",
                  children: React.createElement(PoweredBy$OrcaPaymentPage.make, {})
                }));
}

var make = PaymentElementV2;

export {
  cardsToRender ,
  make ,
}
/* react Not a pure module */
